import {observer} from "mobx-react-lite";
import {stores} from "../../stores";
import {GLOBAL_MEMORY} from "../../stores/memoryStore";
import {ParameterType} from "../../model";
import DEVICES from "../../model/devices.json";
import {getGlobalParameterStateStyle, getPresetParameterStateStyle} from "../../utils/styling";
import {ReactElement} from "react";

interface ParameterProps {
    parameter: ParameterType;
    presetNumber?: number;
    options?: ReactElement<any>[]|undefined;
    // All other props
    [x:string]: any;
}

export const InputList = observer(({parameter, presetNumber = GLOBAL_MEMORY, options, ...rest}: ParameterProps) => {
    function handleChange(e: React.FormEvent<HTMLSelectElement>) {
        const value = parseInt(e.currentTarget.value, 10);
        const clampedValue = Math.min(Math.max(value, parameter.min), parameter.max);
        stores.memory.setValue(parameter, clampedValue, presetNumber);
        stores.midi.save(presetNumber);
    }

    if (!parameter) {
        return <div>PARAMETER NOT FOUND</div>;
    }

    let opts: ReactElement<any>[];
    if (options) {
        opts = options;
    } else {
        if (!parameter.hasOwnProperty('values')) {
            opts = Array.from({length: parameter.max + 1}, (_, i) => {
                if (i < parameter.min) return null;
                return <option key={i} value={i}>{i}</option>;
            }).filter((opt): opt is ReactElement => opt !== null);
        } else {
            if (typeof parameter.values === "string") {
                switch (parameter.values.toLowerCase()) {
                    case "devices.json":
                        const list = DEVICES
                            .map((device: any, i: number) => ({index: i, ...device}))
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .filter((device) => device.index >= parameter.min && device.index <= parameter.max);
                        opts = list.map((device: any) => (
                            <option value={device.index} key={device.index}>
                                [{device.shortName.padEnd(4, ' ')}] {device.name}
                            </option>
                        ));
                        break;
                    default:
                        console.warn("List: invalid list source:", parameter.values);
                        return null;
                }
            } else if (Array.isArray(parameter.values)) {
                opts = parameter.values
                    .map((v: any, i: number) => {
                        if (i < parameter.min || i > parameter.max) return null;
                        return <option value={i} key={i}>{v}</option>;
                    })
                    .filter((opt): opt is ReactElement => opt !== null);
            } else {
                console.warn("List: invalid values type", parameter.values);
                return null;
            }
        }
    }

    const style = parameter.type === "global" ?
        getGlobalParameterStateStyle(parameter.id) :
        getPresetParameterStateStyle(parameter.id, presetNumber);

    const currentValue = stores.memory.getValue(parameter, presetNumber);
    const clampedValue = Math.min(Math.max(currentValue, parameter.min), parameter.max);

    return (
        <div className={`param-input input-list state ${style}`}>
            <select onChange={handleChange} value={clampedValue}>
                {opts}
            </select>
        </div>
    );
});